var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 54,
    viewBox: "0 0 60 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.2727 54L44.0455 46.9091H15C10.8182 46.9091 7.27273 45.4545 4.36364 42.5454C1.45455 39.6364 0 36.0909 0 31.9091C0 28.4182 1.08182 25.3091 3.24545 22.5818C5.40909 19.8364 8.19091 18.0818 11.5909 17.3182C11.7364 16.9545 11.8727 16.6 12 16.2545C12.1818 15.9091 12.3182 15.5364 12.4091 15.1364L1.09091 3.81818L4.90909 0L55.0909 50.1818M15 41.4545H38.5909L16.6364 19.5C16.5455 20.0091 16.4818 20.5091 16.4455 21C16.3909 21.4182 16.3636 21.8727 16.3636 22.3636H15C12.3636 22.3636 10.1182 23.3 8.26364 25.1727C6.39091 27.0273 5.45455 29.2727 5.45455 31.9091C5.45455 34.5455 6.39091 36.8182 8.26364 38.7273C10.1182 40.5455 12.3636 41.4545 15 41.4545ZM56.1818 43.5L52.2273 39.6818C53.0091 39.0455 53.5909 38.3091 53.9727 37.4727C54.3545 36.6364 54.5455 35.6909 54.5455 34.6364C54.5455 32.7273 53.8818 31.1182 52.5545 29.8091C51.2455 28.4818 49.6364 27.8182 47.7273 27.8182H43.6364V22.3636C43.6364 18.6 42.3091 15.3818 39.6545 12.7091C37 10.0545 33.7818 8.72727 30 8.72727C28.7818 8.72727 27.6 8.87273 26.4545 9.16364C25.3091 9.47273 24.2182 9.94545 23.1818 10.5818L19.2273 6.62727C20.8273 5.53636 22.5182 4.7 24.3 4.11818C26.1 3.55455 28 3.27273 30 3.27273C35.3273 3.27273 39.8364 5.12727 43.5273 8.83636C47.2364 12.5273 49.0909 17.0364 49.0909 22.3636C52.2364 22.7273 54.8364 24.0909 56.8909 26.4545C58.9636 28.7818 60 31.5091 60 34.6364C60 36.4545 59.6636 38.1 58.9909 39.5727C58.3 41.1 57.3636 42.4091 56.1818 43.5Z",
    fill: "url(#paint0_linear_3076_21)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3076_21",
    x1: 60,
    y1: 27,
    x2: 0,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80BE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#496D44"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.ca30d066f0e4487d19352a96c858a6ba.svg";
export { ForwardRef as ReactComponent };